/**
 * External Dependencies
 */
import 'jquery';

$(document).ready(() => {
  // console.log('Hello world');
});
